import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NzImageService } from 'ng-zorro-antd/image';
import { forkJoin } from 'rxjs';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService } from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-newField-image-config',
  templateUrl: './newField-image-config.component.html',
  styleUrls: ['./newField-image-config.component.scss']
})
export class AtwNewFieldImageConfig implements OnInit {
  isCollapsed: boolean = false;
  isShowConfirmPopup: boolean = false;
  isConfirmLoading: boolean = false; // biến kiểm tra khi đang xử lý dữ liệu
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() type: any; // xem đang ở page hay admin
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() blocks_of_page?: any; // lấy dữ liệu blocks_of_page trên page
  effect_hover = [];
  isApplyShadow: boolean = false; // Cho phép thêm | chỉnh sửa bóng
  effect_hover_data: any = {};
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
  previewUploadUrl: string | null = null; // url preview trong vùng kéo thả
  dragging = false; // biến kiểm tra người dùng dùng rời con trỏ khỏi vùng upload mà chưa thả
  customize = [];
  style_fields = [
    {
      title: "thong_so_co_ban",
      index: 1,
      isDrop: false
    },
    {
      title: "bo_loc_hinh_anh",
      index: 2,
      isDrop: false
    },
    {
      title: "do_bao_phu",
      index: 3,
      isDrop: false
    },
    {
      title: "bo_tron",
      index: 4,
      isDrop: false
    },
    {
      title: "do_bong",
      index: 5,
      isDrop: false
    },
    {
      title: "cau_hinh_chi_tiet_hieu_ung",
      index: 6,
      isDrop: false
    },
    {
      title: "bien_doi",
      index: 7,
      isDrop: false
    }, {
      title: "them_lien_ket",
      index: 8,
      isDrop: false
    },
    {
      title: 'do_bao_phu',
      index: 9,
      isDrop: false,
    },
    {
      title: 'dieu_chinh_vien',
      index: 10,
    },
    {
      title: 'nen_bieu_tuong',
      index: 11,
    },
  ];
  id_subproject: any;
  subproject = null;
  resolution = null;
  lookupGroupArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  newFields = [];
  currentField: any;
  template:any; 

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private nzImageService: NzImageService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.getNewFileds();
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    );
    this.resolution = this.subproject.resolution;

    // Kiểm tra nếu chưa có config thì thêm để người dùng không cần xóa thêm lại
    if (!this.config.hasOwnProperty('position_onscroll')) {
      this.config.position_onscroll = {
        type: 0,
        top: 0,
      };
    }

    if (!this.config.hasOwnProperty('is_top_page')) this.config.is_top_page = false; 
    if (!this.config['image-fullscreen']?.hasOwnProperty('toggle_fullscreen')) {
      this.config['image-fullscreen'] ??= {};
      this.config['image-fullscreen'].toggle_fullscreen = false;
    }

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/objects_sample/basic/customize-newField/customize-newField-template.json'),
      this.http.get('assets/data/effects/image.json'),
    ]).subscribe(([template, effects]: any) => {
      this.template = template;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {}; 
    
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  getNewFileds() {
    this.vhQueryAutoWeb.getNewFields_byFields({ id_main_sector: { $eq: this.staticdata.id_main_sector } })
      .then((newfields: any) => {
        this.newFields = newfields;
        if (this.staticdata.field_custom) {
          this.currentField = this.newFields.find((field) => field.field_custom == this.staticdata.field_custom);
        }
      });
  }

  changeLookupGroup(event) {
    this.staticdata.lookup_group = event;
    this.updateStaticData();
  }

  handleOpenFullscreenPreview() {
    const srcTemp = this.staticdata.img[this.device + '_img'] || 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'
    const img_preview = [
      {
        src: srcTemp,
        height: '90%',
        position: 'fixed',
      },
    ]
    this.nzImageService.preview(img_preview, { nzZoom: 0.9, nzRotate: 0 });
  }

  /** Xử lí xoay lật
   * @param axis : Lật theo trục 'x' | 'y' | 'z' | '-z'
   */
  handleSetTransform(axis) {
    switch (axis) {
      case 'x': // ---Lật dọc
        if (this.config['transform'].transform_rotateX < 360) {
          this.config['transform'].transform_rotateX += 180;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateX -= 360;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'y': // ---Lật ngang
        if (this.config['transform'].transform_rotateY < 360) {
          this.config['transform'].transform_rotateY += 180;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateY -= 360;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case '-z': // --- Xoay trái
        if (this.config['transform'].transform_rotateZ > -360) {
          this.config['transform'].transform_rotateZ -= 45;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'z': // --- Xoay phải
        if (this.config['transform'].transform_rotateZ < 360)
          this.config['transform'].transform_rotateZ += 45;
        this.class['image__boundary'].transform =
          'rotateX(' +
          this.config['transform'].transform_rotateX +
          'deg) ' +
          'rotateY(' +
          this.config['transform'].transform_rotateY +
          'deg) ' +
          'rotateZ(' +
          this.config['transform'].transform_rotateZ +
          'deg) ' +
          'skewX(' +
          this.config['transform'].transform_skewX +
          'deg) ' +
          'skewY(' +
          this.config['transform'].transform_skewY +
          'deg) ';
        break;
      default:
    }
    if (this.type == 'admin') {
            if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_class')) this.objectChoosing['fieldUpdate'].push(this.device+'_class')
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_config')) this.objectChoosing['fieldUpdate'].push(this.device+'_config')
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }
  //Hàm cập nhật giá trị transform
  SetTransform() {
    this.class['image__boundary'].transform =
      'rotateX(' +
      this.config['transform'].transform_rotateX +
      'deg) ' +
      'rotateY(' +
      this.config['transform'].transform_rotateY +
      'deg) ' +
      'rotateZ(' +
      this.config['transform'].transform_rotateZ +
      'deg) ' +
      'skewX(' +
      this.config['transform'].transform_skewX +
      'deg) ' +
      'skewY(' +
      this.config['transform'].transform_skewY +
      'deg) ';
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }

    /**
   * Cập nhật Setups vào database.
   */
  updateSetups() {
    
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { setups: this.objectChoosing.setups })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }
  
  /**
   *Hàm update config vào database.
    */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config,
    });
  }
  /**
   * Hàm update object vào database.
   */
  updateFields(value) {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, value)
      .then((bool: any) => { });
  }
  /**
   *Hàm update class vào database.
    */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => { });
  }
  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: true,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };
  openMapSub: { [name: string]: boolean } = { menu1: true, menu2: false };
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /** Áp dụng đổ bóng
   *   * -> xử lí dữ liệu bóng -> css:  box-shadow: `x y blur color`
   */
  handleSetShadow() {
    if (this.config.check_shadow == false)
      this.class['image__boundary--img']['box-shadow'] = 'none';
    else {
      this.class['image__boundary--img'].transform = 0.8;
      this.class['image__boundary--img'][
        'box-shadow'
      ] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_color}`;
    }

    if (this.type == 'admin') {
            if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_class')) this.objectChoosing['fieldUpdate'].push(this.device+'_class')
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_config')) this.objectChoosing['fieldUpdate'].push(this.device+'_config')
      return;
    }

    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }
  /** Xử lí đổ bóng
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y blur color`
   */
  handleSetPositionShadow() {
    this.class['image__boundary--img'][
      'box-shadow'
    ] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_width}px ${this.config['box-shadow'].box_shadow_color}`;
    if (this.type == 'admin') {
            if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_class')) this.objectChoosing['fieldUpdate'].push(this.device+'_class')
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_config')) this.objectChoosing['fieldUpdate'].push(this.device+'_config')
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  /**
   * remove link khi click vào nút x
   */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }

  /** Xử lí lưu vị trí ảnh
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y`
   */
  handleSetPositionImage() {
    this.class['image__boundary--img'][
      'object-position'
    ] = `-${this.config.image.object_x}px -${this.config.image.object_y}px`;
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_class')) this.objectChoosing['fieldUpdate'].push(this.device+'_class')
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_config')) this.objectChoosing['fieldUpdate'].push(this.device+'_config')
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }

  //Hàm xử lý scale
  scale() {
    this.class['image__boundary--img'][
      'transform'
    ] = `scale(${this.class['image__boundary--img']['transfrom_scale']})`;
    this.updateClass();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    var effect =
      this.objectChoosing[this.device + '_config']['animation-selected'];

    this.class['image__boundary'].transform = '';
    this.class['image']['box-shadow'] = '';
    if (effect.id == '000010') {
      this.class['image__boundary--img']['height'] = '';
    } else if (effect.id == '000007') {
      this.class['image__boundary--img']['filter'] = '';
    } else {
      this.class['image__boundary--img']['height'] = '100%';
      this.class['image__boundary--img']['filter'] =
        'brightness(100%)  contrast(100%)  saturate(100%)   hue-rotate(0deg)   blur(0px)   opacity(100%)   grayscale(0%)';
    }
    if (this.type == 'admin') {
            if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_class')) this.objectChoosing['fieldUpdate'].push(this.device+'_class')
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_config')) this.objectChoosing['fieldUpdate'].push(this.device+'_config')
      return;
    }

    this.updateFields({
      [this.device + '_class']: this.class,
      [this.device + '_config']: this.config,
    });

    this.customize = event;

    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.style_fields[5]);
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['image']['width'] = event.width + 'px';
    if (event.height) this.class['image']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  updateClassAndConfig() {
    if (this.type == 'admin') {
            if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_class')) this.objectChoosing['fieldUpdate'].push(this.device+'_class')
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_config')) this.objectChoosing['fieldUpdate'].push(this.device+'_config')
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }

  onChangeFieldCustom(selectedValue: any) {
    this.currentField = this.newFields.find((field) => field.field_custom == selectedValue);
    const { field_input_location, field_input_type, field_display_type } = this.currentField

    let dataUpdate: any = {}

    if (field_input_location == 'user') {
      if (field_input_type.includes('select')) {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'select__boundary'
        }
      }

      if (field_input_type.includes('input') || field_input_type == 'textarea') {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'input__boundary'
        }
      }

      if (field_display_type == 'text' && field_input_type == 'ckeditor') {
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'text'
        }
      }
    } else if (field_input_location == 'admin') {
      if (field_display_type.includes('select')) {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'select__boundary'
        }
      }

      if (field_display_type == 'radio') {
        // dùng group image vì group input phải có [id]="'boundary'+data._id"
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'radio'
        }
      }

      if (field_display_type == 'text') {
        dataUpdate = {
          resize_group: 'text',
          resize_field: 'text'
        }

        if(field_input_type == 'ckeditor') {
          dataUpdate.resize_group = 'image'
        }
      }

      if (field_display_type == 'image') {
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'image'
        }
      }
    }

    dataUpdate = {
      ...dataUpdate,
      desktop_class: {
        ...this.template[dataUpdate.resize_field]
      },
      tablet_landscape_class: {
        ...this.template[dataUpdate.resize_field]
      },
      tablet_portrait_class: {
        ...this.template[dataUpdate.resize_field]
      },
      mobile_landscape_class: {
        ...this.template[dataUpdate.resize_field]
      },
      mobile_portrait_class: {
        ...this.template[dataUpdate.resize_field]
      },
      staticdata: this.staticdata
    }

    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, dataUpdate)
  }
}
